import { render, staticRenderFns } from "./NewCampaignModalLoader.vue?vue&type=template&id=e99fa8c6&scoped=true"
import script from "./NewCampaignModalLoader.vue?vue&type=script&lang=js"
export * from "./NewCampaignModalLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99fa8c6",
  null
  
)

export default component.exports